// Mixins
import { toastMessageMixins } from '@/app/mixins/utils/toast-message-mixins';

export default {
    name: 'TransactionStatus',
    mixins: [
        toastMessageMixins
    ],
    mounted() {
        this.setLatitudePay();
    },
    methods: {
        setLatitudePay(){
            let location = null;

            if(this.$route.path === "/pet-transaction-status"){
                location = 'products';
            }else{
                location = 'dog-purchase';
            }

            const {
                gatewayReference,
                merchantReference,
                transactionReference
            } = this.$route.query;
           
            let latitudePay = {
                gatewayReference,
                merchantReference,
                transactionReference,
                location
            }
            
            this.$store.commit('setLatitudePay', latitudePay);
            
            //if (message === "The payment was approved.") {
                this.$router.push('/transaction-successful-page');
            
        }
    }
}